import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgEditSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3.922c-.95 0-1.86.377-2.53 1.048l-.502.501.032.03 5 4.999.03.031.5-.5a3.578 3.578 0 00-2.53-6.11zm.97 7.668a.792.792 0 01-.03-.03l-5-4.998a.774.774 0 01-.03-.032l-8.94 8.94a.75.75 0 00-.22.53v4c0 .415.336.75.75.75h4a.75.75 0 00.53-.22l8.94-8.94z",
    fill: "currentColor"
  })));
}

export { SvgEditSolid as ReactComponent };
